var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-firm-basedata", {
            attrs: {
              cols: 8,
              "form-context": _vm.initialFormContexts.firmBasedata,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-functions", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmFunctions,
            },
            on: { saved: _vm.handleFirmFunctionsSaved },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("csp-desktop-firm-accounting", {
            attrs: {
              cols: 8,
              "form-context": _vm.initialFormContexts.firmAccounting,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-bank-account", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmBankAccount,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("csp-desktop-firm-assignments", {
            ref: "firmAssignments",
            attrs: {
              cols: 8,
              "form-context": _vm.initialFormContexts.firmAssignments,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-appraisers", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmAppraisers,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("csp-desktop-firm-presets", {
            attrs: {
              cols: 8,
              "form-context": _vm.initialFormContexts.firmPresets,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-record-process", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmRecordProcess,
            },
          }),
          _vm._v(" "),
          _vm.showAssignedCarDealer
            ? _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("csp-desktop-car-dealer-assignments", {
                    attrs: {
                      "items-ajax-url": `/api/desktop/firms/${_vm.firmId}/car-dealer-assignments`,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("csp-desktop-firm-remarks", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmRemarks,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-documents", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmDocuments,
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-firm-files", {
            attrs: {
              cols: 4,
              "form-context": _vm.initialFormContexts.firmFiles,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4 mb-4" },
        [
          _c("csp-desktop-firm-configurable-documents", {
            attrs: {
              cols: 8,
              "context-id": _vm.firmId,
              "context-type": "firm",
              "form-context": _vm.initialFormContexts.firmConfigurableDocuments,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }